import { createFileRoute } from "@tanstack/react-router";
import { InvestorUpdates } from "@/components/InvestorUpdates";

function RouteComponent() {
  return <InvestorUpdates />;
}

export const Route = createFileRoute("/_authenticated/investor-updates/")({
  component: RouteComponent,
  staticData: { page: "fundraising" },
});
